module.exports = __webpack_public_path__ + "static/media/three.47790b2c.svg";